import classNames from "classnames"
import { format } from "date-fns"
import React from "react"

type CalendarDayPickerDayPropsType = {
  date: Date
  isToday?: boolean
  selected?: boolean
  disabled?: boolean
  onSelect: (date: Date) => void
  onMouseEnter?: (date: Date, disabled: boolean) => void
  onMouseLeave?: (date: Date) => void
}

function CalendarDayPickerDay({
  date,
  isToday,
  selected,
  disabled,
  onSelect,
  onMouseEnter,
  onMouseLeave,
}: CalendarDayPickerDayPropsType) {
  const handleSelectDate = () => {
    !disabled && onSelect(date)
  }

  return (
    <button
      className={classNames("cobalt-CalendarDayPicker__day", {
        "cobalt-CalendarDayPicker__day--today": isToday,
        "cobalt-CalendarDayPicker__day--selected": selected,
        "cobalt-CalendarDayPicker__day--disabled": disabled,
      })}
      onMouseEnter={() => {
        onMouseEnter?.(date, !!disabled)
      }}
      onMouseLeave={() => {
        onMouseLeave?.(date)
      }}
      onClick={handleSelectDate}
      data-day={format(date, "yyyy-MM-dd")}
      type="button"
    >
      <div className="cobalt-CalendarDayPicker__day-inner">
        {date.getDate()}
      </div>
    </button>
  )
}

function areEqual(
  prevProps: CalendarDayPickerDayPropsType,
  nextProps: CalendarDayPickerDayPropsType,
) {
  return prevProps.selected === nextProps.selected
}

const MemoizedComponent = React.memo(CalendarDayPickerDay, areEqual)
MemoizedComponent.displayName = "CalendarDayPickerDay"

export { MemoizedComponent as CalendarDayPickerDay }
